/*
 * @Author: lbh
 * @Date: 2020-12-24 18:31:42
 * @LastEditors: lbh
 * @LastEditTime: 2025-08-16 17:17:38
 * @Description: file content
 */
import axios from "../../util/http";
let origin = axios.host();
let memberWeb = origin + "/member-web/api";
let riceponRestaurant = origin + "/ricepon-restaurant/api";
let riceponGsa = origin + "/ricepon-gsa/api";
let riceponSystem = origin + "/ricepon-system/api";
let riceponOrder = `${origin}/ricepon-order/api`;

const checkDefaultParams = (params) => {
  if (!params.lng) params.lng = "114.16692809506448";
  if (!params.lat) params.lat = "22.300917736946108";
  return params;
};

// 查詢餐廳專屬信息
export const getShop = (params) =>
  axios.get(riceponRestaurant + "/public/exclusive/get", params);

// 查詢 餐廳列表
export const getRestaurantNew = (params) =>
  axios.post(memberWeb + "/restaurant/getRestaurantNew", params);

// 查詢 餐厅详情
export const getCanteenDetail = (params) =>
  axios.post(memberWeb + "/restaurant/getRestaurantInfoById", params);

// 查詢 起送費
export const queryDeliveryFee = (params) =>
  axios.post(riceponGsa + "/gsa/queryDeliveryFee", params);

/**
 * ? 查詢外送自取服務
 * @param {object} params
 * @param {string} params.brandId - 品牌ID
 * @returns {Promise<boolean>} - 返回是否支持外送自取服務 (true/false)
 */
export const getDeliveryTakeoutStatus = (params) =>
  axios.get(riceponRestaurant + "/restaurant/getDeliveryTakeoutStatus", params);

/**
 * ? 查詢品牌門店
 * @param {object} params
 * @param {string} params.brandId - 品牌ID
 * @param {string} params.lng - 經度
 * @param {string} params.lat - 緯度
 * @param {number} params.pageIndex - 頁碼
 * @param {number} params.pageSize - 每頁數量
 * @returns {Promise}
 */
export const findRestaurantAllList = (params) => {
  params = checkDefaultParams(params);
  return axios.get(
    riceponRestaurant + "/restaurant/findRestaurantAllList",
    params
  );
};

/**
 * ? 餐廳列表
 * @param {object} params
 * @param {string} params.brandId - 品牌ID
 * @param {string} params.lng - 經度
 * @param {string} params.lat - 緯度
 * @returns {Promise}
 */
export const findRestaurantList = (params) => {
  params = checkDefaultParams(params);
  return axios.get(
    riceponRestaurant + "/restaurant/findRestaurantList",
    params
  );
};

/**
 * ? 餐廳詳情
 * @param {object} params
 * @param {string} params.restId - 餐廳ID
 * @param {string} params.lng - 經度
 * @param {string} params.lat - 緯度
 * @returns {Promise}
 */
export const getRestaurantDetail = (params) => {
  params = checkDefaultParams(params);
  return axios.get(
    riceponRestaurant + "/restaurant/getRestaurantDetail",
    params
  );
};

/**
 * ? 品牌簡介
 * @param {object} params
 * @param {string} params.id - 品牌ID
 * @returns {Promise}
 */
export const getBrandDesc = (params) =>
  axios.get(riceponRestaurant + "/brand/getBrandDesc", params);

// 查詢 餐牌
export const shopMenuNew = (params) =>
  axios.post(memberWeb + "/food/shopMenuNew", params);

// 查詢 掃碼點餐
export const getScanById = (params) =>
  axios.post(memberWeb + "/scan/getScanById", params);

// 查詢 scan 信息
export const getScanMenu = (params) =>
  axios.post(memberWeb + "/scan/getScanMenu", params);

// ? 新的 掃碼點餐 訂單接口
export const scanOrderDetail = params => axios.get(`${riceponRestaurant}/scan/orderDetails`, params)


// 掃碼點餐 主用戶 解綁
export const unbundingQrcode = (params) =>
  axios.post(memberWeb + "/scan/unbundingQrcode", params);

// 查詢 細項
export const findFoodCombo = (params) =>
  axios.post(memberWeb + "/food/findFoodCombo", params);

// app 查詢品牌詳情
export const getBrandInfoByIdOth = (params) =>
  axios.post(memberWeb + "/brand/getBrandInfoByIdOth", params);

// 查詢外送服務
export const checkOrderLimit = (params) =>
  axios.post(memberWeb + "/order/checkOrderLimit", params);

// 查詢自取服務
export const checkZiquLimit = (params) =>
  axios.post(memberWeb + "/order/checkZiquLimit", params);

// 自取 查詢送單詳情
export const takeOutAddressAndRest = (params) =>
  axios.post(memberWeb + "/takeOutScan/takeOutAddressAndRest", params);

// 查詢 預點餐 餐種
export const scanRestaurantCode = (params) =>
  axios.post(memberWeb + "/qrcode/scanRestaurantCode", params);

// 取消收藏 餐廳
export const delFavorite = (params) =>
  axios.post(memberWeb + "/restaurant/delFavorite", params);

// 固定碼相關接口

/**
 * 固定碼 掃碼接口
 * @param {memberId,secretKey,qrCode,orderId} params
 * @returns
 */
export const scanTableQrcode = (params) =>
  axios.post(`${riceponOrder}/qrcode/scanTableQrcodeNew`, params);

/**
 * 檢查餐廳校驗碼是否正確
 * @param {restaurantId,restaurantCheckCode} params
 * @returns
 */
export const opcheckRestaurantCheckCode = (params) =>
  axios.get(`${riceponRestaurant}/restaurant/checkRestaurantCheckCode`, params);

/**
 * 掃碼點餐. 食品添加後台緩存
 * @param {*} params
 * @returns
 */
export const addFoodRedis = (params) =>
  axios.post(`${riceponRestaurant}/shopRedis/add`, params);

/**
 * 掃碼點餐. 食品從緩存中讀取
 * @param {*} params
 * @returns
 */
export const getFoodRedis = (params) =>
  axios.get(`${riceponRestaurant}/shopRedis/get`, params);

/**
 * 掃碼點餐. 食品刪除後台緩存
 * @param {*} params
 * @returns
 */
export const clearFoodRedis = (params) =>
  axios.post(`${riceponRestaurant}/shopRedis/clear`, params);

/**
 * 自助碼點餐首頁
 * @param {*} params
 * @returns
 */
export const selfServiceCode = (params) =>
  axios.get(`${riceponRestaurant}/public/exclusive/selfServiceCode`, params);
/**
 * 根據用戶id  獲取 訂閱賬戶信息
 * http://gingersoft.tpddns.cn:53000/project/29/interface/api/10044
 * @param { memberId } params
 * @returns
 */
export const getWhatsappSubscriptionByMemberId = (params) =>
  axios.get(`${riceponRestaurant}/whatsappSubscription/getByMemberId`, params);

/**
 * h5--獲取自取訂閲跳轉url
 * http://gingersoft.tpddns.cn:53000/project/29/interface/api/10050
 * @param {
 *  orderType 消息類型 1 外送 2 自取 3 領券 4 購買外送單數 5 訂單數餘額報警 6會員升級、7優惠券到期、
 *                    8 優惠券使用、9 消費訂單積分通知（使用、增加）、10積分到期、11 積分清零、
 *                    12 商品換領 13 會員降級，14 循环派券 15 自取訂閲、16 訂閲後自取下單'、 17 排隊通知、
 *                    18 叫號通知、 19 過號通知、 23 品牌URL訂閲發送消息，24 品牌URL訂閲回復消息，
 *                    25 WhatsApp訂閲領券消息，26 WhatsApp訂閲領券成功消息
 *  restaurantId 餐廳id
 *  orderId 訂單id
 * } params
 * @returns
 */
export const getByRestaurantIdAndOrderType = (params) =>
  axios.get(
    `${riceponRestaurant}/restaurantWhatsAppConfig/getByRestaurantIdAndOrderType`,
    params
  );

/**
 * h5--獲取餐廳是否開啟訂閱（開啟時有數據，沒開啟沒數據）
 * http://gingersoft.tpddns.cn:53000/project/29/interface/api/10062
 * @param {
 *  orderType 	消息類型 1 外送訂單 2 自取訂單 3 領券 4 購買外送單數  5  訂單數餘額報警 6 會員升級、7優惠券到期、
 *                      8 優惠券使用、 9 消費訂單積分通知（使用、增加）、10積分到期、11 積分清零、12 商品換領
 *                      13 會員降級 14 循環派券 15 自取訂閲 16 訂閲后自取下單 ',
 *  restaurantId 餐廳id
 *  brandId 品牌id
 * } params
 * @returns
 */
export const getRestaurantWhatsAppConfig = (params) =>
  axios.get(`${riceponRestaurant}/restaurantWhatsAppConfig/getCheck`, params);

/**
 * 叫號是否開啟簡潔模式
 * @param {*} params
 * @returns
 */
export const callNumberSwitch = (params) =>
  axios.get(`${riceponRestaurant}/public/brandConfig/get`, params);

// 獲取品牌拓展表配置
export const getBrandConfigList = (params) =>
  axios.get(
    riceponRestaurant + "/brandConfig/brand/getBrandConfigList",
    params
  );

/**
 * * 查詢品牌會員等級信息
 * @param {*} params
 * @returns
 */
export const getMemberTypeEquity = (params) =>
  axios.get(`${riceponRestaurant}/member/getMemberTypeEquity`, params);

/**
 * * http://192.168.1.76:3000/project/29/interface/api/12278
 * * 查詢 餐廳列表, 及 距離
 * @param {
 *  ? brandId
 *  ? restaurantId
 *  ? mapX
 *  ? mapY
 *  ? type 1自取   2外送
 * } params
 * @returns
 */
export const getRestaurantInfoAtlas = (params) =>
  axios.get(
    `${riceponRestaurant}/restaurantInfo/getRestaurantInfoAtlas`,
    params
  );

/**
 * * 根據品牌ID獲取品牌擴展表信息
 * @param {brandId} params
 * @returns
 */
export const getBrandInfoExtByBrandId = (params) =>
  axios.get(
    `${riceponRestaurant}/public/brandInfoExt/getBrandInfoExtByBrandId`,
    params
  );

/**
 * * 查詢餐種食品
 * @param {
 *  restaurantId：餐廳ID
 *  summaryId：餐種ID
 * } params
 * @returns
 */
export const getSummaryProductList = (params) =>
  axios.get(
    `${riceponRestaurant}/summaryProduct/getSummaryProductList`,
    params
  );

/**
 * * 查詢 餐廳配置來源
 * @param {
 *  * brandId
 * } params
 * @returns
 */
export const getBrandBottomFunction = (params) =>
  axios.get(`${riceponRestaurant}/public/brand/getBrandBottomFunction`, params);

/**
 * * 查詢 品牌下 whatsapp 消息是否開啟 以及 模版內容
 * @param {
 * orderType：消息類型：25 品牌URL訂閲
 * brandId：品牌ID
 * memberId：當前登錄的會員ID
 * } params
 * @returns
 */
export const getBrandCheck = (params) =>
  axios.get(`${riceponRestaurant}/whatsAppConfig/getBrandCheck`, params);

/**
 * * 根据用户id和品牌id查询用户可购买等级
 * @param {*} params
 * @returns
 */
export const getMemberTypeByMemberId = (params) =>
  axios.get(`${riceponRestaurant}/member/getMemberTypeByMemberId`, params);

/**
 * * 獲取時段
 * @param {*} params
 * @returns
 */
export const getPeriodList = (params) =>
  axios.get(`${riceponRestaurant}/period/getPeriodList`, params);

/**
 * * 獲取假期列表
 * @param {
 *  brandId：品牌ID
 * } params
 * @returns
 */
export const getHolidayList = (params) =>
  axios.get(`${riceponSystem}/public/system/getHolidayList`, params);

/**
 * * 智能訂閱 - 根據phone和type檢查是否已存在訂閱記錄，如果不存在則新增訂閱記錄
 * @param {
 *  numberId 排隊id（必傳）
 *  type 訂閱類型：1-WhatsApp，2-短信，3-公眾號（必傳）
 *  phone 手機號碼（可選）
 *  accountId 賬號id（可選）
 *  memberId 會員id（可選）
 * } params
 * @returns
 */
export const ensureSubscription = (params) =>
  axios.post(
    `${riceponRestaurant}/subscriptionRecord/ensureSubscription`,
    params
  );

/**
 * * 獲取 會員活動 領券記錄
 * @param {
 *  * restaurantId
 *  * memberId
 * } params
 * @returns
 */

export const getMemberActivityCouponIsRead = (params) =>
  axios.get(
    `${riceponRestaurant}/restaurant/activitySubDis/getMemberActivityCouponIsRead`,
    params
  );
